import { useQuery } from "@tanstack/react-query";
import { googleCalendarApi } from "../api/googleCalendarApi";

export function useGoogleCalendarStatusQuery() {
  return useQuery({ queryKey: ["perfil", "google-calendar-status"], queryFn: googleCalendarApi.getStatus });
}
